import React, {useContext, useEffect, useState} from 'react';
import {TableColumn, TableSettings} from "../../../tableSettings";
import AbstractListView, {
  DataFetchResult,ExportRowRenderer,ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../common/AbstractListView";
import constants from '../../../constants';
import {amsUsersList,} from '../tableSettings';
import {Search} from "../../../filtering";
import {
  DateRenderer,DateTimeRenderer,NullableCheckboxIconRenderer,TextAlignLeftRenderer,TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import JobListViewContext, { RightClickContext } from '../../common/JobListViewContext';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import {JobNames} from '../../../framework.core/JobNames';
import {AmsUserListItem} from '../../../fms.data/models/AmsUserListItem';
import * as XCol from '../../../framework.core/XExportColumn';
import PrimaryButton from "../../../ui/PrimaryButton";
import { ActionButtonItem, borderColors, splitMenuItemsIntoSections } from '../../../ui/ActionButton';
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../ui/menu/Menu';
import ViewUser from './implementation/ViewUser';
import IfmsModal from '../../../ui/IfmsModal';
import { findSecurityTask } from '../../../util';
import ApplicationContext from '../../../ApplicationContext';
import { FmsSecTask } from '../../../fms.core/constants';
import { nullableCheckBoxValue } from '../../common/commonExportFormat';
import { AddIconButton, DeleteIconButton, EditIconButton, ViewIconButton } from '../../../ui/IconButton';

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const jobListContext = useContext(JobListViewContext);

  const items = [
    { label: 'New', shortcut: 'F2', separator: false },
    { label: 'View', shortcut: 'F9', separator: false },
    { label: 'Edit', shortcut: 'F3', separator: true },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
    { label: 'Copy', shortcut: 'Ctrl+F2', separator: false },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      // case 0:
      //   view();
      //   break;
      // case 1:
      //   switchToAmsHbl();
      //   break;
      case 3:
        jobListContext.triggerTableSearch('F5');
        break;
      // case 3:
      //   switchToAmsMbl();
      //   break;
      case 4:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      case 5:
        jobListContext.reloadData();
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function ViListCommands() {
  // <chuck date="2026-09-21" desc="List 기능이 제대로 다시 만들어 진 후에 복구">
  // const [popupMode, setPopupMode] = useState('none');
  // const jobListContext = useContext(JobListViewContext);
  // const appContext = useContext(ApplicationContext);
  
  // const selectedElement = jobListContext.selectedElement as AmsUserListItem;
  // const listSec = findSecurityTask(appContext, FmsSecTask.AMSUser);
  
  // function dismissUserView() {
  //   setPopupMode('none');
  //   jobListContext.dismissPopupRow();
  // }

  // const hasSelectedRow = !!selectedElement;
  // const canBeDeleted = hasSelectedRow && listSec?.grantDel;

  // let title = popupMode === 'view' ? 'View User' : popupMode === 'edit' ? 'Edit User' : 'New User';
  
  // return (
  //   <div>
  //     <div className="ifms-common-no-vertical-separator">
  //       {appContext.suntekSettings?.company?.billingsTabVersion === 2 ?  <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}/> : <></>}
  //       <AddIconButton name='amsUser-list-add-button' disabled={!hasSelectedRow} onClick={() => setPopupMode('new')} useText iconMode />
  //       <ViewIconButton name='amsUser-list-view-button' disabled={!hasSelectedRow} onClick={() => setPopupMode('view')} useText iconHeight='26px' />
  //       <EditIconButton name='amsUser-list-edit-button' disabled={!hasSelectedRow} onClick={() => setPopupMode('edit')} useText/>
  //       <DeleteIconButton name='amsUser-list-delete-button' disabled={!canBeDeleted} onClick={()=>{}} useText/>        
  //       {appContext.suntekSettings?.company?.billingsTabVersion === 2 ? <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"} /> : <></>}
  //     </div>    
  //     <IfmsModal isBlueHeader onCancel={dismissUserView} draggable isOpen={popupMode !== 'none' || !!jobListContext.viewPopupRow} title={title} width="760px">
  //       <ViewUser onPopupClose={dismissUserView} mode={popupMode} selectedElementId={popupMode === 'edit' || popupMode === 'view' ? selectedElement?.id ?? '' : ''} />
  //     </IfmsModal>
  //   </div>
  // );
  // </chuck>
  return null;
}

function ViListToolbar() {
  return null;
}

function formatData(data:Array<AmsUserListItem>) {
  return data;
}

function ViListViewExtras() {
  useFunctionKeys({onFunction: onFunctionKey});

  const jobListContext = useContext(JobListViewContext);

  const [unprocessedFkey, setUnprocessedFkey] = useState<string|null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey:string) {
    if (['F11'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  return null;
}

function AfterMemoLogButtonCommands() {
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const listSec = findSecurityTask(appContext, FmsSecTask.AMSUser);

  const selectedElement = jobListContext.selectedElement as AmsUserListItem;
  const hasSelectedRow = !!selectedElement;
  const canBeCopied = hasSelectedRow && listSec?.grantAdd;

  return (
    <>
      <PrimaryButton name='amsUser-list-copy-button' disabled={!canBeCopied} size={'extrasmall'}>Copy/Paste</PrimaryButton>
    </>
  )
}

/**
 * Concrete implementation for AMS User List screen
 *
 * @class UsersListView
 * @extends {AbstractListView}
 */
 class UsersListView extends AbstractListView {
  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(JobNames.AMSUser, 'AmsUserListItem',
    AmsUserListItem.calculateSearchParameters(search),
    pageNum,
    limit,
    search.pageSize,
    search.pagePerBatch,
    'AMS');
    
    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return { data: formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number): Promise<Array<any>> {
    const apiResult = await api.getListItems(JobNames.AMSUser, 'AmsUserListItem',
    AmsUserListItem.calculateSearchParameters(search),
      pageNum,
      limit,
      pageSize,
      pagePerBatch,
      'AMS'
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return formatData(apiResult.entities);
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(): ListRowRenderer[] {
    return AmsUserListItem.getExportCollection().map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if(x.dataIndex === "status") {
        colRenderer.Cell = () => <span></span>
        colRenderer.Header = () => <span></span>;
      }
      else if(x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({accessor: 'status', changedValue: (value: any)=> { return value['status'] === 'PC' ? 'Period Close' : ''}});    
    //colRenderer.push({accessor: 'active', changedValue: (value: any)=> { return nullableCheckBoxValue(value['active'])}});
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'userID',
      orderByAscending: true,
    };
  }

  getTableSettings(): TableSettings {
    const tsettings = amsUsersList;
    const cols = AmsUserListItem.getExportCollection();
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });

    return tsettings;
  }

  renderCommands() {
    return (
      <ViListCommands />
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ViListToolbar />
    );
  }


  renderExtras() {
    return <ViListViewExtras />
  }

  getViewUrlFor() {
    return '';
  }

  getListViewTitle() {
    return 'AMS User List';
  };


  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  // <chuck date="2026-09-21" desc="List 기능이 제대로 다시 만들어 진 후에 복구" />
  // commandsAfterFilterBtn():React.ReactNode{
  //   return <AfterMemoLogButtonCommands />
  // }
  // </chuck>

  hasMemo(): boolean {
    return false;
  }
};

export default UsersListView;
